module.exports = __webpack_public_path__ + "img/bg-04.ea47c9ac.jpg";